module.exports = __webpack_public_path__ + "img/cube.8b091916.svg";